<script setup>
import { onMounted } from 'vue';

// // Component imports
import FluxButton from '@/components/FluxButton/FluxButtonComp.vue';

const props = defineProps({
  hasDismissal: {
    type: Boolean,
    default: false,
  },
  hasProgress: {
    type: Boolean,
    default: false,
  },
  hasProgressBegun: {
    type: Boolean,
    default: false,
  },
  hasOrbs: {
    type: Boolean,
    default: false,
  },
  isFocusOnDismiss: {
    type: Boolean,
    default: false,
  },
  question: {
    type: String,
    default: '',
  },
  triviaOptions: {
    type: Array,
    default: () => [],
  },
  focusIndex: {
    type: Number,
    default: 0,
  },
  progressDuration: {
    type: Number,
    default: 15000,
  },
});

const emit = defineEmits(['componentReady']);

onMounted(() => {
  emit('componentReady');
});
</script>

<template>
  <div
    class="trivia-card trivia-input"
    :class="{
      'trivia-input--open': props.hasProgress && props.hasProgressBegun,
    }"
  >
    <div class="trivia-card__container">
      <div
        v-if="props.hasOrbs && props.hasProgress && props.hasProgressBegun"
        class="orb io1"
      ></div>

      <div
        v-if="props.hasOrbs && props.hasProgress && props.hasProgressBegun"
        class="orb io2"
      ></div>

      <div
        v-if="props.hasOrbs && props.hasProgress && props.hasProgressBegun"
        class="orb io3"
      ></div>

      <div
        v-if="props.hasOrbs && props.hasProgress && props.hasProgressBegun"
        class="orb io4"
      ></div>

      <div
        v-if="props.hasOrbs && props.hasProgress && props.hasProgressBegun"
        class="orb io5"
      ></div>

      <div class="trivia-card__wrapper">
        <div class="trivia-card__contents">
          <div class="trivia-card__header">
            <span class="trivia-card__header-copy">Trivia</span>
          </div>

          <div class="trivia-card__question">
            <span class="trivia-card__question-copy">{{ props.question }}</span>
          </div>

          <div
            class="trivia-card__options"
            :class="{
              'has-dismissal': props.hasDismissal,
            }"
          >
            <div
              v-for="item in props.triviaOptions"
              :key="item.optionLabel"
              class="trivia-card__option-button"
            >
              <FluxButton
                class="trivia-card__option-button-text"
                :class="{ active: item.optionIndex === props.focusIndex }"
                :button-copy="item.optionEntry"
              />
            </div>
          </div>
        </div>

        <div
          v-if="props.hasDismissal"
          class="trivia-card__dismissal"
          :class="{ active: props.isFocusOnDismiss }"
        >
          <span class="trivia-card__dismissal-copy">Dismiss</span>
        </div>

        <div v-if="props.hasProgress && props.hasProgressBegun" class="trivia-card__progress">
          <div
            class="trivia-card__progress-bar"
            :class="{
              'trivia-card__progress-bar--closed': !hasProgressBegun,
              'trivia-card__progress-bar--open': hasProgressBegun,
            }"
            :style="{ '--progress-duration': `${props.progressDuration / 1000}s` }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
